module.exports = __webpack_public_path__ + "img/report.3fa41556.png";